/**
 * Infinitely Scrolling Gallery
 */

export default (() => {
  /* eslint-disable no-undef  */
  document.querySelectorAll('.gallery').forEach((gallery) => {
    new Marquee(gallery, {
      startVisible: true,
      pauseOnHover: true,
      duplicated: true,
      speed: 50,
    })
  })
  /* eslint-enable no-undef  */
})()
